import styled from 'styled-components';
import React from 'react';

const StyledFormGroup = styled.div`
display: block;
color: ${props => props.theme.main};
font-weight: 500;
text-align: center;
`;

export const Label = styled.label`
display: flex;
flex-direction: column;
user-select: none;
text-align: left;
margin-bottom: 2.5rem;
font-weight: bold;
font-size: 1.2rem;
`;

const StyledInput = styled.input`
display: block;
border-radius: 3px;
border: 1px solid ${props => props.theme.main};
color: ${props => props.theme.main};
flex: 1 1 auto;
font-size: 1.5rem;
padding: .5rem 1rem;
pointer-events: none;
text-align: center;
margin-top: .25rem;
user-select: none;
`;

const TouchableInput = React.forwardRef((props: any, ref: any) => {
  return (
    <StyledInput
      value={props.value}
      placeholder={props.placeholder}
      type={props.type}
      style={{ display: props.hidden ? 'none' : '' }}
      ref={ref}
      readOnly={true}
    />
  )
});;

const FormGroup = (props: any) => {
  return (
    <StyledFormGroup
      style={{ display: props.hidden ? 'none' : '' }} >
      {props.children}
    </StyledFormGroup>
  )
}

interface LabeledInputProps {
  id: string;
  show: boolean;
  value: string;
  label: string;
  placeholder?: string;
  autofocus?: boolean;
};

export const LabeledInput = React.forwardRef((props: LabeledInputProps, ref: any) => {
  return (
    <FormGroup hidden={!props.show}>
      <Label>
        {props.label}
        <TouchableInput
          value={props.value}
          placeholder={props.placeholder}
          hidden={!props.show}
          autoFocus
          ref={ref} />
      </Label>
    </FormGroup>
  );
});